import { NavigateFunction } from "react-router-dom";
import * as Yup from "yup";
import { TReactSetState, TUseTranslationTfn } from "../../data/AppType";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  handleError,
  prepareMessageFromParams,
  toastError,
  toastSuccess,
} from "../../utils/AppFunctions";
import { routePublic } from "../../routes/PublicRoutePath";
import { RESET_PASSWORD } from "../../services/Endpoints";

export interface IResetPassForm {
  new_password: string;
  confirm_password: string;
  token: string;
}

export const validationSchemaResetPass = (t: TUseTranslationTfn) =>
  Yup.object({
    new_password: Yup.string()
      .required(
        prepareMessageFromParams(t("error_message_required"), [
          ["fieldName", t("new_password")],
        ])
      )
      .max(
        18,
        prepareMessageFromParams(t("error_message_max_length"), [
          ["fieldName", t("new_password")],
          ["max", "18"],
        ])
      )
      .min(
        8,
        prepareMessageFromParams(t("error_message_min_length"), [
          ["fieldName", t("new_password")],
          ["min", "8"],
        ])
      )
      .matches(
        /\d/,
        prepareMessageFromParams(t("error_message_required_number"), [
          ["fieldName", t("new_password")],
        ])
      )
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        prepareMessageFromParams(
          t("error_message_required_special_character"),
          [["fieldName", t("new_password")]]
        )
      )
      .matches(
        /[A-Z]/,
        prepareMessageFromParams(t("error_message_required_uppercase"), [
          ["fieldName", t("new_password")],
        ])
      ),
    confirm_password: Yup.string()
      .required(
        prepareMessageFromParams(t("error_message_required"), [
          ["fieldName", t("confirm_password")],
        ])
      )
      .oneOf(
        [Yup.ref("new_password")],
        prepareMessageFromParams(t("error_message_match"), [
          ["fieldName", t("confirm_password")],
        ])
      ),
  });

export const initialValuesResetPass = {
  new_password: "",
  confirm_password: "",
};

export const submitResetPassword = async (
  values: IResetPassForm,
  navigation: NavigateFunction,
  setLoading: TReactSetState<boolean>,
  t: TUseTranslationTfn
) => {
  setLoading(true);
  try {
    const { new_password, confirm_password, token } = values;
    const payload = {
      new_password: new_password,
      confirm_password: confirm_password,
      token: token,
    };
    const resetPassword = await RESET_PASSWORD(payload);
    if (resetPassword && resetPassword.code === DEFAULT_STATUS_CODE_SUCCESS) {
      toastSuccess(resetPassword.message);
      navigation("/" + routePublic.login);
    } else {
      toastError(resetPassword.message);
    }
  } catch (e: any) {
    toastError(e?.resultLogin?.data.title || MESSAGE_UNKNOWN_ERROR_OCCURRED);
    handleError(e, "submitResetPassword");
  } finally {
    setLoading(false);
  }
};
